import { useOperatorSession } from '@/hooks/useOperatorSession'
import { ConnectGate } from './ConnectGate'

export function RequireOperatorRole({ children }: { children: React.ReactNode }) {
    const { status } = useOperatorSession()
    if (status !== 'ready') return <ConnectGate />
    return <>{children}</>
}
